export const PlayerMessageChannels = {
    GetLimitsHistory: "GetLimitsHistory",
    GetPlayer: "GetPlayer"
};
//# sourceMappingURL=index.js.map